import { createContext, useCallback, useContext, useState } from "react";
import { productService } from "../services/productService";

const ProductContext = createContext();

export function ProductProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [products, setProducts] = useState([]);

  const fetchProducts = useCallback(async () => {
    setLoading(true);
    try {
      const data = await productService.getAll();
      setProducts(data);
      setError("");
    } catch (err) {
      console.error("Erreur fetch produits:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const createProduct = async (product) => {
    setLoading(true);
    setError("");
    try {
      const result = await productService.create(product);
      await fetchProducts();
      setSuccess("✅ Produit ajouté avec succès!");
      setTimeout(() => setSuccess(""), 3000);
      return result;
    } catch (err) {
      const errorMsg = err.message || "Erreur lors de la création du produit";
      setError(errorMsg);
      console.error("❌ Erreur création produit:", err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const removeProduct = useCallback((id) => {
    setProducts(prev => prev.filter(p => p.id !== id));
  }, []);

  return (
    <ProductContext.Provider value={{
      products,
      fetchProducts,
      removeProduct,
      createProduct,
      loading,
      error,
      success,
      setLoading,
      setError,
      clearError: () => setError(""),
      clearSuccess: () => setSuccess(""),
    }}>
      {children}
    </ProductContext.Provider>
  );
}

export const useProducts = () => {
  const context = useContext(ProductContext);
  if (!context) {
    throw new Error("useProducts doit être utilisé dans ProductProvider");
  }
  return context;
};